import { useEffect, useState } from "react";

const KEY = "senderProfile";

export function getSenderProfile() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

export function useSenderProfile() {
  const [profile, setProfile] = useState(getSenderProfile);

  useEffect(() => {
    const onStorage = () => setProfile(getSenderProfile());
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const save = (next) => {
    localStorage.setItem(KEY, JSON.stringify(next));
    setProfile(next);
  };

  return [profile, save];
}
